import { render, staticRenderFns } from "./AccountingBooksReceiptForm.vue?vue&type=template&id=188b8c3d&"
import script from "./AccountingBooksReceiptForm.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksReceiptForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksReceiptForm.vue?vue&type=style&index=0&id=188b8c3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports